import {BaseVueEntity} from "@/entities/BaseVueEntity";
import {isDefined} from "@/utils";
import Stand from "@/entities/Stand";

class SocialLink {
  private readonly _type: string;
  private readonly _url: string;

  constructor(socialLink) {
    this._type = socialLink.TYP;
    this._url = socialLink.URL;
  }


  get type(): string {
    return this._type;
  }

  get url(): string {
    return this._url;
  }

  get urlWithProtocol(): string {
    if (this._url) {
      if (!/^https?:\/\//i.test(this._url)) {
        return 'https://' + this._url;
      }
      return this._url;
    }
    return undefined;
  }
}

export class Exhibitor extends BaseVueEntity {

  private readonly _id: string;
  private readonly _name: string;
  private readonly _logo: string;
  private readonly _web: string;
  private readonly _address: string;
  private readonly _plz: string;
  private readonly _city: string;
  private readonly _country: string;
  private readonly _email: string;
  private readonly _info: string;
  private readonly _phone: string;
  private readonly _themes: string[];
  private readonly _themesDisplay: string[];
  private readonly _sortOrder: string;
  private readonly _stand: string;
  private readonly _hall: string;
  private readonly _stands: Stand[];
  private readonly _socials: SocialLink[];


  private readonly searchValues = ['_name', '_info', '_country', '_plz', '_city']

//TODO
  public _logoPath: string;

  constructor(entity, logoPath) {
    super();
    this._id = entity.ID;
    this._name = entity.NAME;
    this._address = entity.ADRESSE;
    this._country = entity.LAND;
    this._logo = entity.LOGO;
    this._plz = entity.PLZ;
    this._city = entity.STADT;
    this._web = entity.WEB;
    this._email = entity.EMAIL;
    this._info = entity.INFO;
    this._phone = entity.TELEFON;
    this._themes = entity.THEMEN;
    this._themesDisplay = entity.THEMEN_ANZEIGE;
    this._sortOrder = entity.S_ORDER;
    this._stand = entity.STAND;
    this._hall = entity.HALLE;
    if (isDefined(entity.SOCIAL)) {
      this._socials = entity.SOCIAL.map(s => new SocialLink(s));
    }

    if (isDefined(entity.STAENDE)) {
      this._stands = entity.STAENDE.map(e => new Stand(e));
    }

    if (process.env.VUE_APP_ENABLE_PRODUCTS === 'true') {
      this.searchValues.push('_products');
    }

    this._logoPath = logoPath;
  }


  public getLogoUrl(): string {
    return process.env.VUE_APP_BACKEND_URL + '/' + this._logoPath + this._logo;
  }

  public hasSearchValue(value: string): boolean {
    for (const prop of this.searchValues) {
      if (isDefined(this[prop])) {
        if (Array.isArray(this[prop]) && this[prop].length > 0) {
            for (let element of this[prop]) {
              if (element.toLowerCase().indexOf(value) > -1) {
                return true;
              }
            }
        } else if (this[prop].toLowerCase().indexOf(value) > -1) {
          return true;
        }
      }
    }
    return false;
  }

  public getFirstLetter(): string {
    return this._name.charAt(0).toUpperCase();
  }


  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  get logo(): string {
    return this._logo;
  }

  get webWithProtocol(): string {
    if (this._web) {
      if (!/^https?:\/\//i.test(this._web)) {
        return 'https://' + this._web;
      }
      return this._web;
    }
    return undefined;
  }

  get web(): string {
    return this._web;
  }

  get address(): string {
    return this._address;
  }

  get plz(): string {
    return this._plz;
  }

  get city(): string {
    return this._city;
  }

  get country(): string {
    return this._country;
  }

  get email(): string {
    return this._email;
  }


  get info(): string {
    return this._info;
  }

  get phone(): string {
    return this._phone;
  }

  get themes(): string[] {
    return this._themes;
  }


  get themesDisplay(): string[] {
    return this._themesDisplay;
  }

  get sortOrder(): string {
    return this._sortOrder;
  }


  get stands(): Stand[] {
    return this._stands;
  }


  get stand(): string {
    return this._stand;
  }

  get location(): string {
    let location = '';

    if (isDefined(this._plz)) {
      location += this._plz;
    }
    if (isDefined(this._city)) {
      location += ` ${this._city}`
    }
    if (isDefined(this._country)) {
      if (location.trim() === '') {
        location += `${this._country}`
      } else {
        location += `, ${this._country}`
      }
    }
    if (location.trim() === '') {
      return undefined;
    }
    return location;
  }

  get plzAndCity(): string {
    let result = '';
    if (isDefined(this._plz)) {
      result += `${this._plz}`;
    }
    if (isDefined(this._city)) {
      if (result === '') {
        result += `${this._city}`;
      } else {
        result += ` ${this._city}`;
      }
    }
    return result;
  }


  get socials(): SocialLink[] {
    return this._socials;
  }
}
